import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'

export const CategoriesGridLoader = () => (
	<div style={{ display: `flex`, gap: 8 }}>
		<SkeletonLoader width={240} height={64} borderRadius={8} />
		<SkeletonLoader width={240} height={64} borderRadius={8} />
		<SkeletonLoader width={240} height={64} borderRadius={8} />
	</div>
)
